import React from "react";
import classNames from "classnames";

import { compose } from "redux";
import withTranslations from "../../../../../../hocs/withTranslations";
import LandingTypography from "../../../../landingPage/pages/Homepage/components/LandingTypography";
import greenTickIcon from "../assets/green-tick.svg";
import megaphoneIcon from "../assets/megaphone.svg";
import useIsDesktop from "../../../../landingPage/hooks/useIsDesktop";

const VotingButton = ({ translate, checked, onClick, loading }) => {
  const isDesktop = useIsDesktop();

  return (
    <LandingTypography>
      <button
        onClick={onClick}
        disabled={loading}
        className={classNames(
          "bg-white rounded-full border-none outline-none flex flex-row gap-3 text-xs line-height-125 font-semibold text-black p-3 align-center text-left",
          {
            "text-sm": isDesktop,
            "text-xs": !isDesktop,
            "opacity-60": loading,
            "outline-green": checked
          }
        )}
      >
        <img
          src={checked ? greenTickIcon : megaphoneIcon}
          alt={""}
          width={20}
          height={20}
          className={"shrink-0"}
        />
        <span>
          {checked
            ? translate("voting-button_checked")
            : translate("voting-button_not-check")}
        </span>
      </button>
    </LandingTypography>
  );
};

export default compose(withTranslations)(VotingButton);
